// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Scene_6_wrapper__18TXO"};